import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { Movie } from "../../fetcher/src/types";

import { keyframes } from "@emotion/react";
import { SortOrder } from "../types";
import { getSortOrder, saveSortOrder } from "../storage-interface/sortOrder";
import { MovieView } from "./MovieView";
import {
  getFavoritedList,
  getSeenList,
  toggleFavorite,
  toggleSeen,
} from "../storage-interface/toggleSeen";
import { searchBehavior } from "./searchbehavior";
import {
  getOnlyFavorites,
  getOnlySeen,
  saveOnlyFavorites,
  saveOnlySeen,
} from "../storage-interface/seen";

export const MovieBrowser = () => {
  const [movieList, setMovieList] = useState<{ data: Movie[] }>();
  const [sortOrder, setSortOrder] = useState<keyof typeof SortOrder>(
    getSortOrder()
  );
  const [queryString, setQueryString] = useState<string>("");
  const [onlyUnseen, setOnlyUnseen] = useState<boolean>(!getOnlySeen());
  const [onlyFavorites, setOnlyFavorites] = useState<boolean>(
    getOnlyFavorites()
  );
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [seen, setSeen] = useState(getSeenList());
  const [favorites, setFavorite] = useState(getFavoritedList());

  useEffect(() => {
    fetch("./movieData.json").then((e) =>
      e.json().then((resp: { data: [] }) => setMovieList({ data: resp.data }))
    );
  }, []);
  console.log(seen);

  useEffect(() => {
    searchInputRef.current?.focus();
  }, [movieList]);

  if (!movieList) {
    return (
      <Container>
        <LoadingContainer>
          <div>
            <LoadingMessage>Trying to load movies...</LoadingMessage>
          </div>
        </LoadingContainer>
      </Container>
    );
  }

  return (
    <Container>
      <SearchContainer>
        <SearchBar>
          <SearchInput
            type="text"
            placeholder="search title and description"
            ref={searchInputRef}
            onKeyDown={({ key }) => {
              if (searchInputRef.current && key == "Enter") {
                setQueryString(searchInputRef.current.value);
              }
            }}
          />
          <SearchButton
            onClick={() => {
              if (searchInputRef.current) {
                setQueryString(searchInputRef.current.value);
              }
            }}
          >
            Search
          </SearchButton>
        </SearchBar>
        <SearchSubBar>
          <SortSelect
            onChange={({ target: { value } }) => {
              const valAsString = value as keyof typeof SortOrder;
              saveSortOrder(valAsString);
              setSortOrder(valAsString);
            }}
            defaultValue={sortOrder}
          >
            {Object.entries(SortOrder).map(([entry, prettyText]) => (
              <option key={entry} value={entry}>
                {prettyText}
              </option>
            ))}
          </SortSelect>
          <SubFilter>
            <label htmlFor="onlyFavorites">only starred</label>
            <input
              id="onlyFavorites"
              type={"checkbox"}
              checked={onlyFavorites}
              onClick={() => {
                setOnlyFavorites(!onlyFavorites);
                saveOnlyFavorites(!onlyFavorites);
              }}
            />
          </SubFilter>
          <SubFilter>
            <label htmlFor="onlyUnseen">only unseen</label>
            <input
              id="onlyUnseen"
              type={"checkbox"}
              checked={onlyUnseen}
              onClick={() => {
                setOnlyUnseen(!onlyUnseen);
                saveOnlySeen(onlyUnseen);
              }}
            />
          </SubFilter>
        </SearchSubBar>
      </SearchContainer>
      <MovieColumnContainer>
        <MovieColumn>
          <>
            {searchBehavior({
              movieList,
              sortOrder,
              queryString,
              favorites,
              seen,
              onlyUnseen: onlyUnseen,
              onlyFavorites,
            }).map((entry) => {
              return (
                <MovieView
                  seen={seen.includes(`${entry.title}/${entry.release.date}`)}
                  favorited={favorites.includes(
                    `${entry.title}/${entry.release.date}`
                  )}
                  handleFavorited={() => {
                    setFavorite(toggleFavorite(entry));
                  }}
                  handleSeen={() => {
                    setSeen(toggleSeen(entry));
                  }}
                  key={entry.title}
                  movie={entry}
                />
              );
            })}
          </>
        </MovieColumn>
      </MovieColumnContainer>
    </Container>
  );
};

const Container = styled.div({ color: "white" });
const MovieColumnContainer = styled.div({
  display: "flex",
  justifyContent: "center",
});
const MovieColumn = styled.div({
  width: "95vw",
  justifyContent: "space-between",
  display: "flex",
  flexWrap: "wrap",
});

const SearchButton = styled.button({
  height: "35px",
  border: "none",
  backgroundColor: "lightgray",
});

const SearchContainer = styled.div({
  position: "sticky",
  top: "0px",
  backgroundColor: "#221111",
  height: "13vh",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  boxShadow: "5px 10px 18px #221111",
  justifyContent: "center",
});

const SearchInput = styled.input({
  width: "70vw",
  height: "30px",
});

const LoadingContainer = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "80vh",
});

const shake = keyframes({
  "0%": { transform: "translate(1px, 1px) rotate(0deg)" },
  "10%": { transform: "translate(-1px, -2px) rotate(-1deg)" },
  "20%": { transform: "translate(-3px, 0px) rotate(1deg)" },
  "30%": { transform: "translate(3px, 2px) rotate(0deg)" },
  "40%": { transform: "translate(1px, -1px) rotate(1deg)" },
  "50%": { transform: "translate(-1px, 2px) rotate(-1deg)" },
  "60%": { transform: "translate(-3px, 1px) rotate(0deg)" },
  "70%": { transform: "translate(3px, 1px) rotate(-1deg)" },
  "80%": { transform: "translate(-1px, -1px) rotate(1deg)" },
  "90%": { transform: "translate(1px, 2px) rotate(0deg)" },
  "100%": { transform: "translate(1px, -2px) rotate(-1deg)" },
});

const LoadingMessage = styled.h1({
  animation: shake + " 0.1s",
  animationIterationCount: "infinite",
});

const SortSelect = styled.select({ height: "30px" });

const SearchBar = styled.div();
const SearchSubBar = styled.div({
  display: "flex",
  width: "100%",
  alignItems: "center",
  paddingTop: "1vh",
  justifyContent: "space-evenly",
});

const SubFilter = styled.div({ display: "flex", alignItems: "center" });
